import axios from 'axios';
import { toast } from 'sonner';

import notification from '../utils/notification';
import { SET_USERS, SET_USER_ONLINE, SET_USER_OFFLINE } from './types';

export const setUsers =
	({ users }) =>
	async (dispatch) => {
		dispatch({ type: SET_USERS, payload: users });
	};

export const setUserOnline = (_user) => async (dispatch) => {
	dispatch({ type: SET_USER_ONLINE, payload: _user });
};

export const setUserOffline = (_user) => async (dispatch) => {
	dispatch({ type: SET_USER_OFFLINE, payload: _user });
};

export const createNewUser = (user) => async (dispatch) => {
	const res = await axios.post('/api/team/create-new-user', { user });

	const { data } = res;

	if (data.error) {
		const message =
			data.message ||
			'There was an error creating your user. Please refresh the page and try again.';
		dispatch(notification('Error', message, true));
		return { error: true, message };
	}

	if (data.users) {
		dispatch({ type: SET_USERS, payload: data.users });
		if (data.emailWarning) toast.warning('Teammate added', { description: data.emailWarning, duration: 10000 });
		else dispatch(notification('Success', `Created new user: ${user.username}`, false));
		return { error: false, emailWarning: data.emailWarning };
	}

	return { error: true };
};

export const editUser = (user) => async (dispatch) => {
	const res = await axios.post('/api/team/edit-user', { user });

	const { data } = res;

	if (data.error) {
		const message =
			data.message ||
			'There was an error editing your user. Please refresh the page and try again.';
		dispatch(notification('Error', message, true));
		return { error: true };
	}

	if (data.users) {
		dispatch({ type: SET_USERS, payload: data.users });
		dispatch(
			notification('Success', `Updated user: ${user.username}`, false)
		);
		return { error: false };
	}

	return { error: true };
};

export const deleteUser = (user) => async (dispatch) => {
	const res = await axios.post('/api/team/delete-user', { user });

	const { data } = res;

	if (data.error) {
		const message =
			data.message ||
			'There was an error deleting your user. Please refresh the page and try again.';
		dispatch(notification('Error', message, true));
		return { error: true };
	}

	if (data.users) {
		dispatch({ type: SET_USERS, payload: data.users });
		dispatch(notification('Success', `Deleted user.`, false));
		return { error: false };
	}

	return { error: true };
};
